var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,13h10c0.6,0,1-0.4,1-1V2h33v5h2V1c0-0.6-0.4-1-1-1H12l0,0c-0.1,0-0.2,0-0.3,0.1h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2l0,0 l-11,11l0,0c-0.1,0.1-0.1,0.2-0.2,0.3v0.1C0.1,11.8,0,11.9,0,12l0,0v47c0,0.6,0.4,1,1,1h29v-2H2L2,13L2,13z M3.4,11l3.8-3.8 L11,3.4V11H3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,39H43c-3.9,0-7,3.1-7,7v14h2V46c0-2.8,2.2-5,5-5h1.3l2.8,7.4c0.1,0.3,0.5,0.6,0.9,0.6s0.8-0.3,1.1-0.6l2.8-7.4H53 c2.8,0,5,2.2,5,5v14h2V46C60,42.1,56.9,39,53,39z M48.1,45.2L46.5,41h3.2L48.1,45.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 51,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 55,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,38h2c2.8,0,5-2.2,5-5v-3c0-2.8-2.2-5-5-5h-2c-2.8,0-5,2.2-5,5v3C42,35.8,44.2,38,47,38z M44,30c0-1.7,1.3-3,3-3h2 c1.7,0,3,1.3,3,3v3c0,1.7-1.3,3-3,3h-2c-1.7,0-3-1.3-3-3V30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 49,
    width: 2,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 49,
    width: 2,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,14h-3v-3c0-0.6-0.4-1-1-1H34v2h20v2h-3H23c-0.2,0-0.4,0.1-0.5,0.1l-7.9,3C14.3,17.2,14,17.6,14,18s0.3,0.8,0.6,0.9 l7.9,3c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.2,0h28h8c0.6,0,1-0.4,1-1v-6C60,14.4,59.6,14,59,14z M22,16.5v3.1L17.8,18L22,16.5z M24,16 h26v4H24V16z M58,20h-6v-4h6V20z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 32,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 28,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 32,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 45,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 53,
    width: 2,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeSvgrepoCom);
export default __webpack_public_path__ + "static/media/resume-svgrepo-com.91add1851336d60e1d1344b7e180a71f.svg";
export { ForwardRef as ReactComponent };